.MainContainer{padding-left:40px;width:100%;float:left}
/*# sourceMappingURL=app.component-T2NAZVKT.css.map */
